/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4"

/**
 * @description Type of the token, typically \"Bearer\"
 */
export const tokenTypeSchema = z
  .enum(["Bearer"])
  .describe('Type of the token, typically "Bearer"')
